import React from 'react';

const SocialShare = ({ url, title, image }) => {
  const shareUrl = url || window.location.href;
  const shareTitle = encodeURIComponent(title || 'Check out this product on eBuyWiz!');
  const shareImage = encodeURIComponent(image || '');

  const platforms = [
    {
      name: 'WhatsApp',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.105-1.132l-.295-.176-2.868.852.852-2.868-.176-.295A7.96 7.96 0 014 12c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"/>
        </svg>
      ),
      url: `https://wa.me/?text=${shareTitle}%20${encodeURIComponent(shareUrl)}`,
      color: '#25D366',
    },
    {
      name: 'Facebook',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      color: '#1877F2',
    },
    {
      name: 'X',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      url: `https://twitter.com/intent/tweet?text=${shareTitle}&url=${encodeURIComponent(shareUrl)}`,
      color: '#000',
    },
    {
      name: 'Copy',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
        </svg>
      ),
      onClick: () => {
        navigator.clipboard?.writeText(shareUrl);
        const btn = document.getElementById('share-copy-btn');
        if (btn) { btn.textContent = '✓ Copied!'; setTimeout(() => { btn.textContent = 'Copy'; }, 2000); }
      },
      color: '#6B7280',
    },
  ];

  return (
    <div className="d-flex align-items-center gap-2">
      <small className="text-muted me-1">Share:</small>
      {platforms.map((p) => (
        <a
          key={p.name}
          id={p.name === 'Copy' ? 'share-copy-btn' : undefined}
          href={p.url || '#'}
          target={p.url ? '_blank' : undefined}
          rel="noopener noreferrer"
          onClick={(e) => { if (p.onClick) { e.preventDefault(); p.onClick(); } }}
          className="btn btn-sm border-0 d-flex align-items-center justify-content-center"
          style={{
            width: '34px', height: '34px', borderRadius: '50%',
            color: p.color, background: `${p.color}15`,
            transition: 'all 0.2s',
          }}
          title={`Share on ${p.name}`}
        >
          {p.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialShare;
